import { syncIconPopup as AntdsyncIconPopup } from "@empglabs/backoffice-ui-kit"

const syncIconPopup = (data, ...props) => {
  return AntdsyncIconPopup(data, ...props)
}

export default syncIconPopup
